import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Notification} from '../../../../../models/notification.interface';
import {Usuario} from '../../../../../models/usuario.interface';
import {NotificationService} from '../../../../services/notification/notification.service';


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent implements OnInit, OnDestroy {
  showModal = false;
  totalNotification = 0;
  mensagens: Notification[] = [];
  user!: Usuario;

  private sseSubscription: Subscription;
  constructor(
      private ref: ChangeDetectorRef,
      private readonly service: NotificationService
  ) {
    setInterval(() => {
      this.ref.detectChanges();
    }, 3000);
  }

  ngOnInit(): void {
    this.user = JSON.parse(window.localStorage.getItem('usuario'));
    this.listenNotifications();
  }

  listenNotifications() {
    this.service.getNotifications(this.user.id).subscribe({
      next: notifications => {
        this.mensagens = notifications;
        const busca = notifications.filter(notification => notification.statusNotification === false);
        this.totalNotification = busca.length;
      }
    });
  }


  handleDeleteNotification(event: Event, notification: Notification) {
    event?.stopPropagation();
    this.service.delete(notification.id).subscribe({
      next: () => {
        this.mensagens.splice(this.mensagens.indexOf(notification), 1);
      },
    });
  }
  ngOnDestroy(): void {
  }
  handleOpenModal() {
    this.showModal = !this.showModal;
    this.totalNotification = 0;

    const notifications = this.mensagens.filter(
        message => message.statusNotification === false
    );
    if (notifications.length > 0) {
      notifications.forEach(notify => {
        setTimeout(() => {
          notify.statusNotification = true;
          this.service.update(notify).subscribe();
        }, 1000);
      });
    }
  }

}
